import { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  Drawer,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  alpha,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import { SidebarContext } from "src/contexts/SidebarContext";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import HeaderSearch from "./Search";
import HeaderButtons from "./Buttons";
import HeaderUserbox from "./Userbox";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import Logo from "./Logo";
import React from "react";
import { Link } from "react-router-dom";
import { useBreadcrumbs } from "../../contexts/BreadCrumbsContext";
import { useLocalStorage } from '../../Hooks/LocalStorage';
import { Client, IClinicDTO, ICashMachineDTO } from "../../DashboardApi/api";
import { REACT_APP_PORTAL_API_URL } from "../../../KeyVariables";
const DrawerWrapper = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: 250,
    backgroundColor: alpha(theme.colors.primary.main, 0.95),
    backdropFilter: "blur(3px)",
    color: theme.header.textColor,
    padding: theme.spacing(2),
  },
}));
const HeaderWrapper = styled(Card)(({ theme }) => `
  height: calc(${theme.header.height} - 10px);
  color: ${theme.header.textColor};
  padding: ${theme.spacing(0, 2)};
  right: 0;
  z-index: 6;
  background-color: ${alpha(theme.colors.primary.main, 0.95)};
  backdrop-filter: blur(3px);
  position: fixed;
  justify-content: space-between;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 0;
`);

const IconButtonPrimary = styled(IconButton)(({ theme }) => `
  background: ${theme.colors.alpha.trueWhite[10]};
  color: ${theme.colors.alpha.trueWhite[70]};
  padding: 0;
  width: 42px;
  height: 42px;
  border-radius: 100%;
  margin-left: ${theme.spacing(2)};

  &.active,
  &:active,
  &:hover {
    background: ${alpha(theme.colors.alpha.trueWhite[30], 0.2)};
    color: ${theme.colors.alpha.trueWhite[100]};
  }
`);

const BoxLogoWrapper = styled(Box)(({ theme }) => `
  margin-right: ${theme.spacing(2)};
`);

function Header() {
  const breadcrumbs = useBreadcrumbs();
  const apiUrl = REACT_APP_PORTAL_API_URL;
  const client = new Client(apiUrl);
  //Not a well-considered action
  // const clientpatient2 = new Client(REACT_APP_PATIENT_API_URL);
  const theme = useTheme();
  const [currentUser, setCurrentUser] = useState<any>(null);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    client.getcurrentuser().then(data => setCurrentUser(data));
  }, []);

  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <HeaderWrapper>
      <Box display="flex" alignItems="center" gap={2}>
        <BoxLogoWrapper>
          <Logo url={currentUser?.defaultUrl} />
        </BoxLogoWrapper>
        {
          !isMobile &&
          <>
            <Box flexGrow={1}>
              <Breadcrumbs maxItems={2} aria-label="breadcrumb">
                {breadcrumbs.breadcrumbs.map(({ breadcrumb, path }) => (
                  <Link key={path} to={path} style={{ textDecoration: 'none', color: 'white' }}>
                    {breadcrumb}
                  </Link>
                ))}
              </Breadcrumbs>
            </Box>
            <HeaderSearch />
          </>
        }

      </Box>

      <Box display="flex" alignItems="center">

        {
          !isMobile &&
          <HeaderButtons />
        }
        <Box
          sx={{
            display: { xs: "none", sm: "inline-block" },
          }}
        >
          <Box
            sx={{
              pl: `${theme.spacing(1)}`,
              textAlign: "left",
            }}
          >
            <Box
              sx={{
                fontWeight: ` ${theme.typography.fontWeightBold}`,
                color: "HighlightText",
              }}
            >
              {currentUser?.firstName} {currentUser?.lastName}
            </Box>
            <Box
              sx={{
                color: "HighlightText",
              }}
            >
              {(currentUser?.role)}
            </Box>
          </Box>
        </Box>
        <HeaderUserbox currentUser={currentUser} />
        {isMobile && (
          <IconButtonPrimary color="inherit" onClick={() => setOpenDrawer(true)}>
            <MenuTwoToneIcon />
          </IconButtonPrimary>
        )}
        {/* <Box
          component="span"
          sx={{
            display: { lg: "none", xs: "inline-block" },
          }}
        >
          <Tooltip arrow title="Toggle Menu">
            <IconButtonPrimary color="primary" onClick={toggleSidebar}>
              {!sidebarToggle ? <MenuTwoToneIcon /> : <CloseTwoToneIcon />}
            </IconButtonPrimary>
          </Tooltip>
        </Box> */}

        {/* <HeaderUserbox currentUser={currentUser} />
        <Tooltip arrow title="Toggle Menu">
          <IconButtonPrimary onClick={toggleSidebar}>
            {!sidebarToggle ? <MenuTwoToneIcon /> : <CloseTwoToneIcon />}
          </IconButtonPrimary>
        </Tooltip> */}


        <DrawerWrapper anchor="right" open={openDrawer} onClose={() => setOpenDrawer(false)}>
          <>
            <Grid container gap={2}>
              <Grid item xs={12}>
                <HeaderButtons />
              </Grid>
              <Grid item xs={6}>
            </Grid>
            </Grid>
              <HeaderSearch />
          
         
          </>
        </DrawerWrapper>
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
